<template>
  <bootstrap-collapse :visible="visible">
    <!-- <div class="row">
      <base-alert  :type="filterEmpty > 0 ? 'success' : 'danger'" class="p-1 text-center m-0 col-6">
        {{ filterEmpty > 0 ? `${filterEmpty} itens selecionados` : 'filtro desativado!' }}
      </base-alert>
    </div> -->

    <b-card-body>
      <div class="col-lg-12" style="text-align: right;"></div>
      <!-- <small class="text-muted">Defina valores para o filtro de {{objectName}}</small> -->

      <b-row align-h="between">
        <b-col cols="12" class="column_count_3">
          <div class="d-inline-block" v-for="(prod_uuids, cat) in controllItems" :key="cat">
            <b-form-checkbox class="mb-1" checked="true" @change="selectedCategoriesChanged(cat)">
              <b>{{ cat }}</b>
            </b-form-checkbox>

            <b-form-checkbox :disabled="currentItems.indexOf(poi.uuid) < 0" v-model="selectedItens[poi.uuid]" class="ml-3"
              @change="selectedItensChanged(cat)" v-for="poi in prod_uuids" :key="poi.uuid">
              {{ poi.name }}
            </b-form-checkbox>
          </div>
        </b-col>
        <!-- <b-col align-self="end">
          <base-button icon @click="selectedItens = []" outline type="warning">
            <span class="btn-inner--icon">
              <i class="fas fa-trash" style="padding: 0; margin: -6px -6px -6px -6px;"></i>
            </span>
          </base-button>
        </b-col> -->
      </b-row>

    </b-card-body>
  </bootstrap-collapse>
</template>

<script>
import BootstrapCollapse from "@/components/BootstrapCollapse/BootstrapCollapse";
import { Select, Option, Col } from "element-ui";

export default {
  name: "search-filter-sales",

  props: {
    visible: { type: Boolean, default: true },
    currentItems: { type: Array, default: [] },
    allItems: { type: Array, default: [] },
    objectName: { type: String, default: 'atrativos' }, // produtos para bocapio
    categoryName: { type: String, default: 'Cidade' }, //Categoria para bocapio
  },

  components: {
    BootstrapCollapse,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col
  },

  data() {
    return {
      filterEmpty: 0,
      selectedItens: [],
      selectedCategories: [],
      controllItems: [],
    };
  },

  methods: {
    selectedCategoriesChanged(cat) {
      let idx = this.selectedCategories.indexOf(cat)
      let _selectedItensNames = []
      let _selectedCategories = []
      let _categoryCheck = false
      let _currentCategoryItems = this.controllItems[cat]

      //Category is selected?
      if (idx >= 0) {
        _selectedCategories = this.selectedCategories
        //remove category
        _selectedCategories.splice(idx, 1)
        this.selectedCategories = _selectedCategories
      } else {
        _categoryCheck = true
        //insert category
        this.selectedCategories.push(cat)
      }

      //update checked property of all items from current category
      _currentCategoryItems.forEach((item) => {
        if (this.currentItems.indexOf(item.uuid) >= 0) {
          this.selectedItens[item.uuid] = _categoryCheck
        }
      })

      _selectedItensNames = Object.keys(this.selectedItens).filter(el => this.selectedItens[el])
      this.filterEmpty = _selectedItensNames.length
      this.$emit('billItensSelected', _selectedItensNames)
    },

    selectedItensChanged(cat) {
      let _currentCategoryItems = this.controllItems[cat]
      let _categoryHasItem = false

      _currentCategoryItems.forEach((item) => {
        if (this.currentItems.indexOf(item.uuid) >= 0) {
          _categoryHasItem = _categoryHasItem || this.selectedItens[item.uuid]
        }
      })

      let _selectedItensNames = Object.keys(this.selectedItens).filter(el => this.selectedItens[el])
      this.filterEmpty = _selectedItensNames.length

      this.$emit('billItensSelected', _selectedItensNames)
    },
  },

  mounted() {
    let itemsList = {}
    let categories = []
    let _selectedItens = {}
    let _currentItems = this.currentItems
    let _controllItems = {}

    this.allItems.forEach((item, idx) => {
      let categoryName = (item[this.categoryName] && item[this.categoryName][0]) ? item[this.categoryName][0]['name'] : 'Sem Categoria'
      if (undefined == itemsList[categoryName]) {
        categories.push(categoryName)
        itemsList[categoryName] = []
      }

      if (itemsList[categoryName].indexOf(item.uuid) < 0) {
        itemsList[categoryName].push({uuid: item.uuid, name:item.product_name})
      }
      if (_currentItems.indexOf(item.uuid) < 0) { _selectedItens[item.uuid] = false }
      else { _selectedItens[item.uuid] = true }
    })

    this.selectedItens = _selectedItens
    this.selectedCategories = categories
    categories.sort()
    categories.forEach((cat) => {
      itemsList[cat].sort()
      _controllItems[cat] = itemsList[cat]
    })

    this.filterEmpty = Object.keys(_currentItems).length
    this.controllItems = _controllItems
  },

};
</script>
